import { resolveImagePath } from '@/utils/imageResolver';

export function ApproachDescription() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content Side */}
          <div className="space-y-6">
            <div className="space-y-2">
              <h5 className="text-sm md:text-base text-amber-600 uppercase tracking-wide font-medium">
                virtual couples therapy
              </h5>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-light text-gray-900 leading-tight">
                ELITE VIRTUAL THERAPY: SAVE YOUR MARRIAGE
              </h2>
            </div>

            <div className="space-y-6 text-gray-700">
              {/* Why Choose Us Section */}
              <div>
                <p className="text-lg leading-relaxed">
                  <strong>Why Choose Us?</strong><br />
                  <strong>Brutal Honesty, Real Results</strong><br />
                  Our elite virtual therapy delivers transformative sessions for high-achieving couples 
                  committed to saving their marriage. Experience lasting improvements in trust, 
                  communication, and passion.
                </p>
              </div>

              {/* Meet Kendra Section */}
              <div>
                <p className="text-lg leading-relaxed">
                  <strong>Meet Kendra</strong><br />
                  <strong>Expert in Virtual Therapy</strong><br />
                  Kendra specializes in high-end virtual couples therapy, offering innovative methods 
                  for real change. Schedule a consultation today to rebuild your relationship.
                </p>
              </div>

              {/* Our Approach Section - The Main Focus */}
              <div className="bg-amber-50 p-6 rounded-lg border-l-4 border-amber-600">
                <p className="text-lg leading-relaxed font-medium">
                  <strong className="text-amber-700">Our Approach</strong><br />
                  <strong className="text-amber-700">No Excuses, Only Results</strong><br />
                  <span className="text-gray-800">
                    We provide a confidential, results-focused environment. Experience elite therapy 
                    designed for meaningful, lasting change.
                  </span>
                </p>
              </div>
            </div>

            {/* Call to Action Button */}
            <div className="pt-4">
              <a 
                href="/virtual-couples-therapy" 
                className="inline-flex items-center gap-2 bg-amber-600 hover:bg-amber-700 text-white px-8 py-3 rounded-md font-medium transition-colors duration-200"
              >
                Read More
                <svg 
                  className="w-4 h-4" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M9 5l7 7-7 7" 
                  />
                </svg>
              </a>
            </div>
          </div>

          {/* Image Side */}
          <div className="flex justify-center lg:justify-end">
            <div className="w-full max-w-md">
              <img
                src={resolveImagePath('/images/therapy-environment-3.jpg')}
                alt="Elegant therapy environment with kintsugi art symbolizing healing and renewal"
                className="w-full h-auto rounded-lg shadow-lg object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}